import React from "react";

const RefundPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="overlay"></div>

      <div className="content-wrapper">
        <div className="privacy-content">
          {/* Header Section */}
          <header className="privacy-header">
            <h1>Refund Policy</h1>
            <h2>Refund Policy for <span className="brand-name">Makemyhouse.Ai</span></h2>
          </header>

          {/* Main Content */}
         <main className="privacy-main">
  {/* Section 1 */}
  <section className="privacy-section">
    <h3>1. Refund & Cancellation Policy</h3>
    <ul>
      <li>Orders can be canceled within 30 minutes of payment for a full refund, provided work has not started.</li>
      <li>Since plans are digitally delivered within 24 hrs, once delivered, they are non-refundable.</li>
      <li>If we fail to deliver within 48 hrs (excluding unforeseen technical issues), you may request a 100% refund.</li>
      <li>Refunds are processed within 7–14 business days via original payment method.</li>
      <li>Service fees for payment processing may be deducted, if applicable.</li>
      <li>If only some deliverables were incomplete/unable to deliver, we will discuss a fair partial refund.</li>
    </ul>
  </section>

  {/* Section 2 */}
  <section className="privacy-section">
    <h3>2. Service Delivery Policy</h3>
    <ul>
      <li>After payment and submission of the 20-question form, plans are generated and delivered within 24 hrs via email or WhatsApp.</li>
      <li>In rare cases of system failure or incomplete inputs, delivery may take up to 48 hrs.</li>
      <li>Deliverables include AI-generated floor plan(s) or elevation(s) as per the chosen package.</li>
      <li>No physical documents are shipped.</li>
    </ul>
  </section>

  {/* Section 3 */}
  <section className="privacy-section">
    <h3>3. Disclaimer</h3>
    <ul>
      <li>Makemyhouse.ai provides AI-generated plans and elevations based on user inputs.</li>
      <li>These are conceptual designs only and should not be treated as final working drawings.</li>
      <li>We do not guarantee accuracy of dimensions, structural stability, or compliance with local building codes.</li>
      <li>Users must consult licensed architects/engineers for approvals, structural drawings, and execution.</li>
      <li>We are not liable for financial, structural, or personal losses arising from use of our designs.</li>
    </ul>
  </section>

  {/* Section 4 */}
  <section className="privacy-section">
    <h3>4. Cookie Policy</h3>
    <ul>
      <li>We use cookies to enhance user experience, track site performance, and run Google/Facebook ads.</li>
      <li>
        Types of cookies:
        <ul>
          <li>Essential – for form submissions and payments.</li>
          <li>Analytics – track usage patterns.</li>
          <li>Marketing – remarketing/ads across platforms.</li>
        </ul>
      </li>
      <li>You can disable cookies in browser settings, but some features may not function properly.</li>
    </ul>
  </section>
</main>


        </div>
      </div>

       <style jsx>{`
        .privacy-container {
          position: relative;
          min-height: 100vh;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800"><rect fill="%23000" width="1200" height="800"/><g fill="%23333"><circle cx="200" cy="150" r="80" opacity="0.1"/><circle cx="800" cy="300" r="120" opacity="0.05"/><circle cx="1000" cy="600" r="100" opacity="0.08"/></g></svg>') center/cover;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        footer {
    display: block !important;
    /* top: 0; */
    bottom: 0;
    width: 100%;
    z-index: 9999;
}
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
          z-index: 1;
        }

       .content-wrapper {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgb(255 255 255 / 0%) transparent;
}

        .content-wrapper::-webkit-scrollbar {
          width: 6px;
        }

        .content-wrapper::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        .privacy-content {
          background: rgba(0, 0, 0, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 40px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .privacy-header {
          text-align: center;
          margin-bottom: 40px;
          border-bottom: 2px solid #4a5568;
          padding-bottom: 30px;
        }

        .privacy-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 15px 0;
          text-shadow: 0 2px 4px rgba(255, 255, 255, 0.1);
        }

        .privacy-header h2 {
          font-size: 1.25rem;
          font-weight: 500;
          color: #a0aec0;
          margin: 0;
        }

        .brand-name {
          font-weight: 700;
          color: #2d3748;
         background: linear-gradient(135deg, #307f3a 0%, #dddae0 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .privacy-main {
          line-height: 1.7;
          color: #e2e8f0;
        }

        .privacy-section {
          margin-bottom: 35px;
          background: rgba(26, 32, 44, 0.6);
          border-radius: 12px;
          padding: 30px;
          border: 1px solid rgba(113, 128, 150, 0.3);
          transition: all 0.3s ease;
        }

        .privacy-section:hover {
          background: rgba(26, 32, 44, 0.8);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }

        .privacy-section h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 20px 0;
          border-left: 4px solid #22792d;
          padding-left: 15px;
        }

        .privacy-section p {
          margin: 0 0 15px 0;
          font-size: 1rem;
          color: #cbd5e0;
        }

        .subsection {
          margin: 20px 0;
          padding: 20px;
          background: rgba(45, 55, 72, 0.5);
          border-radius: 8px;
          border: 1px solid rgba(113, 128, 150, 0.2);
        }

        .subsection h4 {
          font-size: 1.1rem;
          font-weight: 600;
          color: #f7fafc;
          margin: 0 0 12px 0;
        }

        ul {
          margin: 0;
          padding: 0 0 0 20px;
          list-style: none;
        }

        ul li {
          margin: 10px 0;
          padding-left: 20px;
          position: relative;
          color: #cbd5e0;
          font-size: 1rem;
        }

        ul li::before {
          content: "•";
          color: #307f3a;
          font-weight: bold;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }

        ul li:hover {
          color: #ffffff;
          transform: translateX(3px);
          transition: all 0.2s ease;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .privacy-container {
            padding: 10px;
          }

          .privacy-content {
            padding: 25px;
            margin: 10px 0;
          }

          .privacy-header h1 {
            font-size: 2rem;
          }

          .privacy-header h2 {
            font-size: 1.1rem;
          }

          .privacy-section {
            padding: 20px;
            margin-bottom: 25px;
          }

          .privacy-section h3 {
            font-size: 1.3rem;
          }

          .subsection {
            padding: 15px;
          }
        }

        @media (max-width: 480px) {
          .privacy-header h1 {
            font-size: 1.8rem;
          }

          .privacy-header h2 {
            font-size: 1rem;
          }

          .privacy-section h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default RefundPolicy;